<template>
    <div class="pdf">
        <div class="pdf-tab">
            <div class="btn-def" @click.stop="prePage">上一页</div>
            <input class="input_page" placeholder="1" v-model="pageNum" @input="onInput">
            <div class="label-desc">/</div>
            <div class="label-desc">{{pageTotalNum}}</div>
            <div class="btn-def" @click.stop="nextPage">下一页</div>
            <div class="label-desc">缩放: {{scale}}%</div>
            <div class="scale-select">
                <select v-model="selectId" @click="onSelectChange($event)">
                    <option v-for="(options,id) in scaleSelectData" :key="id" :value="options.id">
                        {{options.title}}
                    </option>
                </select>
            </div>
            <div class="btn-def" @click.stop="scaleDown">缩小</div>
            <div class="btn-def" @click.stop="scaleUp">放大</div>
            
            <div v-if="canRotate" class="btn-def" @click.stop="rotate">旋转</div>
        </div>
        <div ref="pageContainer" class="pageContainer">
            <div ref="pdfSizeDiv" class="pdfSizeDiv">
                <pdf v-show="this.pageSizeLoaded" ref="pdf" :src="pdfPath" :page="pageNum" :rotate="pageRotate" @password="password"
                     @progress="loadedRatio = $event"
                     @page-loaded="pageLoaded($event)" @num-pages="pageTotalNum=$event" @error="pdfError($event)"
                     @link-clicked="page = $event">
                </pdf>
            </div>
            <div class="pageLoading" v-if="!this.pageSizeLoaded">
                <div>
                    努力加载中...
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import pdf from 'vue-pdf'

    export default {
        name: 'MyPreview',
        components: {
            pdf
        },
        props: {
            src: {
                type: String,
                required: true,
            },
            canRotate: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                pdfUrl: this.src,//"/upload/2023-02-11/202302111405030086873481741902.pdf",
                pdfPath: "",
                //pdfUrl: "https://xiangjunkeji.cn/CM-API//upload/2023-02-11/202302111405030086873481741902.pdf",
                pageSizeLoaded: false,
                pageSizeList: [],
                pageSize: {p:1,w:1,h:1},
                posX: 0,  //相对左边原点
                pw: 0,    //页面宽度(旋转前)
                ph: 0,    //页面高度(旋转前)
                dw: 0,    //显示div的宽度(旋转后)
                dh: 0,    //显示div的高度(旋转后)
                pageNum: 1,
                pageTotalNum: 1,
                pageRotate: 0,
                scale: 100, //放大系数 默认百分百
                // 加载进度
                loadedRatio: 0,
                curPageNum: 0,

                selectId: 1,
                scaleSelectData:[
                    {id:1, op:"1", title:"实际尺寸"},
                    {id:2, op:"2", title:"适合页面"},
                    {id:3, op:"3", title:"400%", value:400},
                    {id:4, op:"3", title:"200%", value:200},
                    {id:5, op:"3", title:"150%", value:150},
                    {id:6, op:"3", title:"100%", value:100},
                    {id:7, op:"3", title:"75%", value:75},
                    {id:8, op:"3", title:"50%", value:50},
                    {id:9, op:"3", title:"25%", value:25},
                ]
            }
        },
        created() {
        },
        mounted: function () {
            this.pdfPath = pdf.createLoadingTask({
                url: this.$global.Local + this.pdfUrl,
                //引入pdf.js字体，templ
                cMapUrl: 'static/cmaps/', //引入pdf.js字体，templ
                // cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/',
                cMapPacked: true
            })

            this.getPageSize()
        },
        watch: {
            pageNum: function(newVal, oldVal){
                this.setPageSize(newVal)
            }
        },
        computed: {
        },
        methods: {
            // 获取页面尺寸
            getPageSize() {
                let param = new FormData();
                param.append('token', this.$global.token);
                param.append('path', this.pdfUrl);
                let _this = this;
                // 【API请求】----获取印章列表
                _this.api.getPageSize(param).then(res => {
                    // res.data.forEach(item => {
                    //     console.log(item)
                    // });
                    this.pageSizeList = res.data
                    this.pageSizeLoaded = true
                    this.setPageSize(this.pageNum)
                })
            },
            setPageSize(page){
                this.pageSize = this.getSizeByPage(page);
                this.renderSize()
            },
            renderSize(){
                if(this.pageSize!=null){
                    //console.log(this.pageSize)
                    //console.log(this.pageRotate)
                    let w = (this.pageRotate/90%2==0?this.pageSize.w:this.pageSize.h) * this.scale / 100
                    let h = (this.pageRotate/90%2==0?this.pageSize.h:this.pageSize.w) * this.scale / 100
                    let ml = 0
                    let cw = this.$refs.pageContainer.offsetWidth
                    //console.log("cw:"+cw)
                    if(cw > w){
                        ml = (cw-w)/2
                    }
                    this.posX = ml
                    this.pw = this.pageSize.w * this.scale / 100
                    this.ph = this.pageSize.h * this.scale / 100
                    this.dw = w
                    this.dh = h
                    //console.log("w:"+w+"  h:"+h)
                    this.$refs.pdfSizeDiv.style.width = w+"px"
                    this.$refs.pdfSizeDiv.style.height = h+"px"
                    this.$refs.pdfSizeDiv.style.marginLeft = ml+"px"
                    this.$refs.pageContainer.style.width = cw+"px"
                    this.$refs.pageContainer.style.height = (h+20)+"px"
                    this.handlerChange()
                }
            },
            handlerChange(){
                let data = this.getData()
                this.$emit('change', data)
            },
            getData(){
                let data = {
                    pageNum: this.pageNum,
                    pageTotal: this.pageTotal,
                    pageRotate: this.pageRotate,
                    scale: this.scale,
                    left: Math.round(this.posX),
                    pw: Math.round(this.pw),
                    ph: Math.round(this.ph),
                    dw: Math.round(this.dw),
                    dh: Math.round(this.dh),
                    pageSize: this.pageSize?{w: Math.round(this.pageSize.w), h:Math.round(this.pageSize.h)}:{w:1, h:1},
                    pageSizeList: JSON.parse(JSON.stringify(this.pageSizeList)),
                }
                return data
            },
            getSizeByPage(page){
                let ret = null
                this.pageSizeList.forEach(item => {
                    if(item.p == page){
                        ret = item
                    }
                });
                return ret
            },
            password(updatePassword, reason) {
                updatePassword(prompt('password is "123456"'))
                console.log('...reason...')
                console.log(reason)
                console.log('...reason...')
            },
            pageLoaded(e) {
                this.curPageNum = e
            },
            pdfError(error) {
                console.error(error)
            },
            onInput(e){
                let value = e.data
                value=value.replace(/[^\d]/g,'')
                if(value < 1){
                    this.pageNum = 1
                }else if(value > this.pageTotalNum){
                    this.pageNum = this.pageTotalNum
                }else{
                    this.pageNum = parseInt(value)
                }
            },
            prePage() {
                let p = this.pageNum
                p = p > 1 ? p - 1 : this.pageTotalNum
                this.pageNum = p
            },
            nextPage() {
                let p = this.pageNum
                p = p < this.pageTotalNum ? p + 1 : 1
                this.pageNum = p
            },
            scaleUp(){
                let s = this.getScaleNumber(this.scale)
                this.scale += s;
                this.renderSize()
            },
            scaleDown(){
                let s = this.getScaleNumber(this.scale)
                this.scale += -s;
                this.renderSize()
            },
            rotate(){
                this.pageRotate += 90
                this.pageRotate %= 360
                this.renderSize()
            },
            onSelectChange(e){
                let item = this.getScaleItemById(this.selectId)
                if(item.op==='1'){
                    this.scale = 100
                }else if(item.op==='2'){
                    if(this.pageSize!=null){
                        let w = this.$refs.pageContainer.offsetWidth
                        let pw = this.pageRotate/90%2==0?this.pageSize.w:this.pageSize.h
                        this.scale = parseInt(w / pw * 100)
                    }else{
                        this.scale = 100
                    }
                }else if(item.op==='3'){
                    this.scale = item.value
                }
                this.renderSize()
            },
            getScaleItemById(id){
                let ret = null
                this.scaleSelectData.forEach((item)=>{
                    if(item.id==id){
                        ret = item
                    }
                })
                return ret
            },
            getScaleNumber(nowScale){
                if(nowScale<5){
                    return 0
                }else if(nowScale<100){
                    return 5
                }else if(nowScale<200){
                    return 10
                }else if(nowScale<400){
                    return 20
                }else {
                    return 50
                }
            },
        }
    }
</script>
<style lang="less" scoped>
    .pdf {
        width: 100%;
        height: 100%;

        .pdf-tab {
            width: 100%;
            height: 100px;
            background-color: #f5f5f5;
            display: flex;
            align-items: center;
            justify-content: center;

            .btn-def {
                width: 100px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                color: #fff;
                font-size: 24px;
                cursor: pointer;
            }

            .btn-def + .btn-def{
                margin-left: 10px;
            }

            .input_page {
                width: 40px;
                height: 36px;
                line-height: 36px;
                text-align: center;
                font-size: 24px;
                border: solid 0.013333rem #aaaaaa;
                padding-top: 3px;
                box-sizing: border-box;
                margin-left: 5px;
            }

            .label-desc {
                height: 40px;
                line-height: 40px;
                text-align: center;
                font-size: 24px;
                padding: 0 5px;
            }

            .scale-select{
                display:inline-block;
                position:relative;
                z-index:2;
                width:140px;
                height: 36px;
                line-height: 36px;
                font-size: 24px;
                text-align: center;
                text-align-last: center;
                background:#fff;
                box-sizing:border-box;
                border: solid 0.013333rem #aaaaaa;
                margin-right: 5px;
            }
            .scale-select:before{
                content:"";
                position:absolute;
                width:0;
                height:0;
                border:10px solid transparent;
                border-top-color: #109ee7;
                top:50%;
                right:5px;
                cursor:pointer;
                z-index:-2;
                margin-top:-5px;
                font-size: 24px;
                text-align: center;
            }
            .scale-select select{
                width:100%;
                height:40px;
                border:none;
                background:transparent;
                background-image:none;
                -webkit-appearance:none;
                -moz-appearance:none;
                vertical-align:center;
                padding: 0 20px 0 5px;
                font-size: 24px;
                text-align: center;
                margin-top: -2px;
                margin-left: -2px;
            }
            .scale-select select:focus{
                outline:none;
            }
        }
        .pageLoading{
            width: 100%;
            height: 100%;
            text-align: center;
            font-size: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: -40px;
        }
        .pageContainer{
            width: 100%;
            height: 100%;
            display: inline-block;
            white-space: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
            background-color: #f5f5f5;
        }
        .pdfSizeDiv{
            display: inline-block;
            border: solid 0.013333rem #aaaaaa;
            overflow: hidden;
        }
    }

</style>
<style>
    .annotationLayer{
        display: none!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/preview/preview.vue